import { api } from '@/api'
import type { Currency } from '@/api/typings/general.typing'
import type { ApiPaginationResponse, ApiResponse } from '@/api/typings/response.typing'
import type { CurrencyItem } from '@/api/typings/settings.typing'

export function getCurrenciesAction(page: number = 1): Promise<ApiPaginationResponse<CurrencyItem[]>> {
  return api.get<ApiPaginationResponse<CurrencyItem[]>>(`/currencies?page=${page}`)
}

export function createCurrencyAction(payload: {
  title: string
  iso: string
  isoCode: string
  selling_exchange_rate_margin: number | string
  buying_exchange_rate_margin: number | string
}): Promise<ApiResponse<Currency>> {
  return api.post<ApiResponse<Currency>>(`/currencies`, { ...payload })
}

export function updateCurrencyAction(
  id: string,
  payload: {
    title: string
    iso: string
    isoCode: string
    selling_exchange_rate_margin: number | string
    buying_exchange_rate_margin: number | string
  }
): Promise<ApiResponse<Currency>> {
  return api.put<ApiResponse<Currency>>(`/currencies/${id}`, { ...payload })
}

export function deactivateCurrencyAction(id: string): Promise<ApiResponse<Currency>> {
  return api.put<ApiResponse<Currency>>(`/currencies/${id}/deactivate`)
}
export function toggleCurrencyAutoUpdateAction(
  id: string,
  payload: {
    auto_update_enabled: boolean
  }
): Promise<ApiResponse<Currency>> {
  return api.patch<ApiResponse<Currency>>(`/currencies/${id}/auto-update`, { ...payload })
}

export function updateCurrencyExchangeRateAction(
  id: string,
  payload: {
    exchange_rate: number | string
  }
): Promise<ApiResponse<Currency>> {
  return api.patch<ApiResponse<Currency>>(`/currencies/${id}/exchange-rate`, { ...payload })
}
